var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotlinBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.9111V103.822L10.9333 92.6223C16.9778 86.4 36.6222 65.9556 54.6667 47.1111C72.7111 28.2667 90.2222 9.95559 93.6889 6.40003L99.9111 3.05176e-05H49.9556H0V51.9111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8222 58.4L0 116.8V158.133V199.556L99.5556 100C154.311 45.2444 199.111 0.35553 199.111 0.266647C199.111 0.0888672 179.378 -1.52588e-05 155.378 -1.52588e-05L111.556 0.0888672L55.8222 58.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8668 152.178L11.4668 199.556L58.6668 199.822C84.6224 199.911 127.022 199.911 152.711 199.822L199.556 199.556L152.533 152.178C126.667 126.222 105.245 104.889 104.889 104.889C104.533 104.889 83.3779 126.222 57.8668 152.178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlinBadge);
export default __webpack_public_path__ + "static/media/kotlin-badge.5daa205a60d11b198d7ddcb3e73cad24.svg";
export { ForwardRef as ReactComponent };